<template>
  <section class="card" :aria-busy="loading">
    <div v-if="loading" class="table-status" role="status">Loading records…</div>
    <div class="table-wrap" tabindex="0" aria-label="Scrollable records table">
      <table>
        <thead><tr><th v-for="header in headers" :key="header.value" scope="col">{{header.text}}</th></tr></thead>
        <tbody>
          <tr v-for="(item,index) in visible" :key="item[itemKey] || item.id || index">
            <td v-for="header in headers" :key="header.value"><slot :name="'item.'+header.value" :item="item">{{item[header.value]}}</slot></td>
          </tr>
          <tr v-if="!loading && !filtered.length"><td :colspan="headers.length" class="table-status">{{search ? 'No matching records.' : noDataText}}</td></tr>
        </tbody>
      </table>
    </div>
    <div v-if="filtered.length" class="table-footer">
      <span>{{start+1}}–{{Math.min(start+pageSize,filtered.length)}} of {{filtered.length}}</span>
      <div v-if="filtered.length>pageSize"><button type="button" :disabled="currentPage===1" @click="currentPage--">Previous</button><button type="button" :disabled="start+pageSize>=filtered.length" @click="currentPage++">Next</button></div>
    </div>
  </section>
</template>
<script>
export default {
  props:{headers:{type:Array,default:()=>[]},items:{type:Array,default:()=>[]},search:{type:String,default:''},loading:Boolean,itemKey:{type:String,default:'id'},itemsPerPage:{type:Number,default:20},noDataText:{type:String,default:'No records yet.'}},
  data:()=>({currentPage:1}),
  computed:{
    pageSize(){return Math.max(1,this.itemsPerPage);},
    filtered(){const term=this.search.trim().toLocaleLowerCase();return term?this.items.filter(item=>this.headers.some(h=>this.text(item[h.value]).toLocaleLowerCase().includes(term))):this.items;},
    start(){return (this.currentPage-1)*this.pageSize;},
    visible(){return this.filtered.slice(this.start,this.start+this.pageSize);}
  },
  watch:{search(){this.currentPage=1;},items(){this.currentPage=1;}},
  methods:{text(value){if(Array.isArray(value))return value.map(this.text).join(' ');if(value&&typeof value==='object')return Object.values(value).map(this.text).join(' ');return String(value==null?'':value);}}
};
</script>
<style scoped src="./prototype/style.css"></style>
<style scoped src="./prototype/slots-design.css"></style>
<style scoped src="./prototype/hrms-match.css"></style>
<style scoped>
.table-status{padding:24px;color:#667085;text-align:center}.table-footer{display:flex;justify-content:space-between;align-items:center;gap:12px;padding:12px 16px;border-top:1px solid #e2e8f0;font-size:11px;color:#667085}.table-footer button{margin-left:8px}.table-footer button:disabled{opacity:.45;cursor:default}.table-wrap:focus-visible{outline:2px solid #0757b8;outline-offset:-2px}
</style>
